import React from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Hero from '../../../../components/Hero';

const NodeArticleFull = ({ entity, className }) => {
  const classes = classNames(className, 'ArticleFull');

  const type = entity.getIn(['type', 0, 'target_id'], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const mediaItem = entity.getIn(['field_media_item', 0], Map());

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Hero title={title} body={body} imageField={mediaItem} type={type} />
      <Container className="paragraph-group">
        <div className="row">
          {entity.get('field_paragraphs') ? (
            <div className="NodeArticleFullPage__paragraphs col-lg-7 col-12">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      </Container>
    </article>
  );
};

export default NodeArticleFull;
